export default __webpack_public_path__ + "static/media/web.16f2eb8e.svg";